module.exports = __webpack_public_path__ + "static/ebr-7-13f92b33e7dd30f0b449fe5fada94753.jpg";